import { render, staticRenderFns } from "./merchantuserlist.vue?vue&type=template&id=2cbb714e&scoped=true"
import script from "./merchantuserlist.vue?vue&type=script&lang=js"
export * from "./merchantuserlist.vue?vue&type=script&lang=js"
import style0 from "./merchantuserlist.vue?vue&type=style&index=0&id=2cbb714e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbb714e",
  null
  
)

export default component.exports